import { render } from "./manualChecking.vue?vue&type=template&id=c6973e24"
import script from "./manualChecking.vue?vue&type=script&lang=js"
export * from "./manualChecking.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\apps\\appKonferenceStudioW\\v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__